import { Injectable } from '@angular/core';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';
import {
  ClientQuestionnaireCreationOptions,
} from '../../../../../../../../common/src/options/client-questionnaire/client-questionnaire-creation.options';
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";

@Injectable()
export class CreateClientQuestionnaireFactory {
  constructor(private readonly formFactory: FormFactory) {

  }

  create(): AdvancedForm<ClientQuestionnaireCreationOptions> {
    return this.formFactory.create(new ClientQuestionnaireCreationOptions(), [
      new AdvancedFormButton('CREATE', ButtonStyleEnum.Primary, 'Créer le formulaire', ButtonTypeEnum.Submit),
    ]);
  }
}
